import { enderecoStep, DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL } from '../../shared/enderecoSections';
import { termosStep } from '../../shared/termosSections';
import { mergeDadosRequerimentoConfig } from '../../../core/services/dadosRequerimentoConfigUtils';

const paymentConfig = {
  dynamicAmount: true,
  dynamicField: 'formaRecebimento',
  options: {
    ONLINE: {
      name: 'Acesso On-line (Digital)',
      amount: 22.00,
      description: 'Acesso digital ao processo desarquivado'
    },
    FISICA: {
      name: 'Retirada Física na Subseção',
      amount: 38.50,
      description: 'Retirada física do processo na subseção'
    }
  }
};

const protocoloConfig = {
  modeloRequerimento: {
    field: paymentConfig.dynamicField,
    map: { ONLINE: '313', FISICA: '314' }
  },
  tiposAssunto: '831',
  tipoPedido: {
    field: paymentConfig.dynamicField,
    map: { ONLINE: '503', FISICA: '504' }
  }
};

// Confirmado ao vivo: 313 e 314 têm o mesmo shape (Nome/CPFCNPJ + endereço residencial, sem email).
const dadosRequerimentoConfig = mergeDadosRequerimentoConfig(
  {
    campos: [
      { field: 'nomeCompleto', campoNome: 'Nome' },
      { field: 'cpf', campoNome: 'CPFCNPJ' }
    ]
  },
  DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL
);

const tituloConfig = {
  tipoLancamentoId: 48,
  enderecoOrigem: 'residencial'
};

const pedidoDesarquivamentoProcessoConfig = {
  id: 'pedido_desarquivamento_processo',
  nome: 'Desarquivamento de Processo',
  categoria: 'pedidos',
  descricao: 'Solicitação de desarquivamento de processo na OAB/MS',
  icon: 'FaFileAlt',

  documentConfig: {
    required: [
      { id: 'requerimento', tipoDocumentoProcesso: 433, name: 'Requerimento', description: 'Requerimento preenchido e assinado digitalmente', required: true }
    ]
  },

  paymentConfig,
  protocoloConfig,
  tituloConfig,
  dadosRequerimentoConfig,

  steps: [
    {
      id: 'dados_pessoais',
      title: 'Dados Pessoais',
      sections: [
        {
          title: 'Identificação do Requerente',
          fields: [
            { type: 'text', name: 'nomeCompleto', label: 'Nome completo', required: true, placeholder: 'Digite seu nome completo' },
            { type: 'cpf', name: 'cpf', label: 'CPF', required: true }
          ]
        },
        {
          title: 'Forma de Recebimento',
          fields: [
            {
              type: 'radio',
              name: 'formaRecebimento',
              label: 'Escolha a forma de recebimento',
              required: true,
              options: [
                { value: 'ONLINE', label: 'Acesso On-line (Digital)' },
                { value: 'FISICA', label: 'Retirada Física na Subseção' }
              ]
            }
          ]
        }
      ]
    },
    enderecoStep({ autoCep: true }),
    termosStep()
  ]
};

export default pedidoDesarquivamentoProcessoConfig;
